import {useMemo, useRef, useState, useEffect} from "preact/compat";
import {useAppContext} from "../../../../contexts";

const MOCK_DATA = [
    {
        id: 1,
        name: "Brasília - DF",
        code: "DF"
    },
    {
        id: 2,
        name: "Salvador - BA",
        code: "BA"
    },
    {
        id: 3,
        name: "Guarulhos - SP",
        code: "GUA"
    }
]

export const useLocationPicker = () => {
    // Retrieves store data from the app context
    const {storeLocation, setStoreLocation} = useAppContext();

    // State to control the dropdown open state
    const [isOpen, setIsOpen] = useState(false);
    // State to control the filter input value
    const [filterQuery, setFilterQuery] = useState("");

    // All the available store locations
    const {locations, setFullPageLoader} = useAppContext();

    // Memo to store the current selected location and also filter it by the filterQuery state value
    const availableLocations = useMemo(() => {
        return locations.filter(item => {
            return item?.name?.toLowerCase().includes(filterQuery.toLowerCase()) ||
                item?.regionIndex?.toLowerCase().includes(filterQuery.toLowerCase());
        })
    }, [locations, filterQuery]);

    // Memo to store the current selected location
    const currentLocation = useMemo(() => {
        if (locations.length === 0) {
            return storeLocation.name;
        }

        const itemIndex = locations.findIndex(item => item.id === storeLocation.id);

        return locations[itemIndex].name ? locations[itemIndex].name : "?";
        // return "Brasília - DF";
    }, [locations, storeLocation]);

    // A ref to reference both the button and the container to trigger the close effect when clicked outside of them
    const contentRef = useRef();

    // A method to handle the dropdown open state
    const handleOpen = () => {
        setIsOpen(prevState => !prevState);
    }

    // Method to handle the filter value update
    const handleFilter = (e) => {
        // Destructured input value
        const {value} = e.target;

        // Sets the filter query to its respective state
        setFilterQuery(value);
    }

    // Method to handle the location change
    const handleLocationChange = async props => {
        try {
            setFullPageLoader(true);
            // Destructured props
            const {id, name, code} = props;

            // Sets the new location to the local storage
            setStoreLocation({
                id,
                name,
            });

            // Refreshes the page
            window.location.href = `${window.location.pathname}?___store=${code}`;
        } catch (error) {
            console.log(`Erro ao alterar loja: ${error}`);
        } finally {
            setFullPageLoader(false);
        }
    }

    // Closes the dropdown when clicked outside of it using the ref element as a validator
    useEffect(() => {
        document.addEventListener("mousedown", (e) => {
            if (!contentRef.current?.contains(e.target)) {
                setIsOpen(false);
            }
        });
    })

    return {
        isOpen,
        currentLocation,
        availableLocations,
        contentRef,
        handleOpen,
        handleFilter,
        handleLocationChange,
        filterQuery
    }
}
